import {useTranslation} from "@Translation/hooks/useTranslation";
import {DimensionOption, VehicleAddonResponseType} from "@CheckOrder/api/types/GetAddonDataQuery.type";

export default function useGetSelectedVehicleHeightLabel(
    activeOption: { value: number, label: string, activeGroup: VehicleAddonResponseType },
    additionalHeight: DimensionOption | null
) {
    const {
        default: defaultLabel,
    } = useTranslation("check_order.addons.JADL.vehicle.additional_height")

    const getActiveLabel = () => {
        return activeOption.activeGroup.heightOptions.find((option) => (
            option.value === additionalHeight?.value
        ))?.label ?? defaultLabel
    }

    return {
        getActiveLabel,
    }
}